// src/pages/ViewArtifact.jsx
import React, { useEffect, useState } from "react";
import api from "../api";
import {
  Box,
  Paper,
  Typography,
  Button,
  Alert
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";

export default function ViewArtifact() {
  const { id } = useParams();
  const [artifact, setArtifact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await api.get(`/api/artifacts/${id}`);   // 🔥 relative API
        setArtifact(res.data);
      } catch (err) {
        console.error(err);
        setError(
          err?.response?.status === 404
            ? "Artifact not found."
            : "Failed to load artifact. Please check WiFi / Server."
        );
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id]);

  if (loading)
    return (
      <Typography sx={{ textAlign: "center", mt: 4 }}>
        Loading artifact…
      </Typography>
    );

  return (
    <Box>
      <Button onClick={() => navigate("/admin/artifacts")} sx={{ mb: 2 }}>
        ← Back
      </Button>

      <Paper sx={{ p: 3 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {!error && artifact && (
          <>
            <Typography variant="h4" gutterBottom>
              {artifact.title}
            </Typography>

            {artifact.imageUrl && (
              <img
                src={artifact.imageUrl}                 // ✅ Direct relative path
                alt={artifact.title}
                style={{
                  width: "100%",
                  maxHeight: 400,
                  objectFit: "contain",
                  marginBottom: 16
                }}
                onError={(e) => {
                  e.target.src = "/fallback.png";
                }}
              />
            )}

            <Typography variant="body1" sx={{ mb: 2 }}>
              {artifact.description}
            </Typography>

            {artifact.audioUrl && (
              <audio
                controls
                style={{ width: "100%" }}
                onError={() =>
                  alert("Audio file missing. Please check server.")
                }
              >
                <source
                  src={artifact.audioUrl}                // ✅ Direct relative path
                  type="audio/mpeg"
                />
              </audio>
            )}

            <Typography sx={{ mt: 2 }}>
              Visitors: {artifact.visitorCount || 0}
            </Typography>
          </>
        )}
      </Paper>
    </Box>
  );
}
